import { TEAM_MEMBER_LABEL_SELECT_OPTIONS } from '~services/constant/backstage';
import HelperOptions from '~component/helper/helper-options';

// 搜索合同的输入框，对应的字段类型
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;

    return (
      <HelperOptions
        { ...data }
        options={ TEAM_MEMBER_LABEL_SELECT_OPTIONS }
      />
    );
  },
};
